import { Box } from '@chakra-ui/react';
import React from 'react';

import SearchBar from 'ui/snippets/searchBar/SearchBar';

// [Basis chrome] En movil este componente ya solo pinta el buscador.
//
// Traia una cabecera propia -- hamburguesa, logotipo y perfil -- pegada arriba a
// 56px de alto. Con la navbar de la landing, que tambien es sticky y tambien
// lleva marca y menu, habria DOS cabeceras superpuestas y dos hamburguesas. La
// navegacion movil (secciones del explorador, Producto, Proyecto) vive ahora en
// el panel de BasisNavBar, que las reune todas; aqui se queda lo unico que la
// navbar no duplica.
//
// Deja de ser sticky a proposito: dos elementos pegados al mismo borde se pisan.
// El buscador viaja en el flujo, justo debajo de la navbar.
//
// La prop renderSearchBar se conserva porque /search-results inyecta su propia
// barra por ahi (ui/pages/SearchResults.tsx). hideSearchBar tambien: la portada
// y la pagina de una dapp la apagan, y entonces esto no renderiza nada.

type Props = {
  hideSearchBar?: boolean;
  renderSearchBar?: () => React.ReactNode;
};

const HeaderMobile = ({ hideSearchBar, renderSearchBar }: Props) => {
  if (hideSearchBar) {
    return null;
  }

  const searchBar = renderSearchBar ? renderSearchBar() : <SearchBar/>;

  return (
    <Box
      as="header"
      bgColor={{ _light: 'white', _dark: 'black' }}
      display={{ base: 'block', lg: 'none' }}
      px={ 3 }
      py={ 2 }
    >
      { searchBar }
    </Box>
  );
};

export default React.memo(HeaderMobile);
